// extracted by mini-css-extract-plugin
export default {"carouselContainer":"Carousel_carouselContainer__FeQjR","imagesSection":"Carousel_imagesSection__B6mYG","scrollButton":"Carousel_scrollButton__apMU8"};